import React from "react";
import { FileText } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { tos } from "../i18n/tos";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { ScrollArea } from "./ui/scroll-area";

export default function TermsModal({ open, onOpenChange }) {
  const { lang } = useLanguage();
  const doc = tos[lang] || tos.it;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl p-0 gap-0 overflow-hidden">
        <DialogHeader className="px-6 pt-6 pb-4 border-b border-slate-100">
          <DialogTitle className="flex items-center gap-2.5 font-display text-xl text-slate-900">
            <span className="grid place-items-center w-9 h-9 rounded-lg bg-primary/10 text-primary">
              <FileText className="w-5 h-5" />
            </span>
            {doc.title}
          </DialogTitle>
        </DialogHeader>

        <ScrollArea className="max-h-[70vh] px-6 py-5">
          <div className="space-y-6 pr-3">
            {doc.sections.map((s, i) => (
              <section key={i}>
                <h3 className="font-display font-bold text-[15px] text-primary mb-2">
                  {s.h}
                </h3>
                {s.p.map((para, pi) => (
                  <p
                    key={pi}
                    className="text-[13.5px] leading-relaxed text-slate-700 mb-2"
                  >
                    {para}
                  </p>
                ))}
                {s.list && (
                  <ul className="mt-1 space-y-1.5 list-disc pl-5">
                    {s.list.map((li, li2) => (
                      <li key={li2} className="text-[13.5px] leading-relaxed text-slate-700">
                        {li}
                      </li>
                    ))}
                  </ul>
                )}
              </section>
            ))}
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
